import React from "react";
import AITextNotification from "../views/ai-text-notification";
import DashboardSites from "../components/dashboard/DashboardSites";
import DashboardSitemap from "../components/dashboard/DashboardSitemap";
import DashboardOwners from "../components/dashboard/DashboardOwners";
import DashboardMapView from "../components/dashboard/DashboardMapView";
import SensorsDashboard from "../components/dashboard/DashboardSensors";
import Login from "../views/login";
import Message from "../views/message";
import Logout from "../views/logout";
import DailyReport from "../views/reports/daily_report";
import EnvironmentalReport from "../views/reports/environmental_report";
import HumanPowerReport from "../views/reports/human_power_report";
import StandardDailyReport from "../views/reports/standard_daily_report";
import AfterHoursVisitorsReport from "../views/reports/after_hours_visitor_report";
import PPEAwarenessDailyReport from "../views/reports/ppe_awareness_daily_report";
import ReportLibraryPage from "../views/report-library-page";
import SensorDetails from "../views/reports/sensor_details";
import ProfileSettings from "../views/profile-settings";
import ZoneHistory from "../views/zone-history";
import ZoneTimelaps from "../views/zone-timelaps";
import SiteManagement from "../views/site-management";
import ReportsHome from "../views/reports-home";
import FileDashboard from "../views/file-dashboard";
import HowToVideos from "../views/how-to-videos";
import FAQPage from "../views/faq-page";
import VideosHome from "../views/videos-home";
import ErrorPage from "../views/error-page";
import ForgotPassword from "../views/forgot-password";
import VideosLibrary from "../views/videos-library";
import VerifyChallenge from "../views/verify-challenge";
import AdminConsole from "../views//admin-console";
import TimelapseDashboard from "../components/dashboard/TimelapseDashboard";
import PPEReportsLibrary from "../views/ppe-reports-library";
import BIMModels from "../components/BIM/BIMModels";
import BIMViewer from "../components/BIM/BIMViewer";
import RainReport from "../views/reports/rain_report";
import WindReport from "../views/reports/wind_report";
import UptimeReport from "../views/reports/uptime_report";
import ThirdPartyMonitoring from "../views/third-party-monitoring";
import { Outlet, RouterProvider, createBrowserRouter } from "react-router-dom";
import Header from "../components/bootstrap4/Header";
import SessionManager from "../routes/SessionManager";
import SSO from "../views/sso";
import Procore from "../views/procore";
import LiveStream from "./streaming/LiveStream";
import PasswordRenewal from "../views/password-renewal";
import DashboardLeadership from "./dashboard/DashboardLeadership";
import VideosHistorical from "../views/videos-historical";
import ChatbotWidget from "./ChatbotWidget";
import SiteMonitoringReport from "../views/reports/site_monitoring_report";
import SecurityIncidentReport from "../views/reports/security_incident_report";
import WhircIncidentManager from "../views/reports/whirc_incident_manager";
import CustomerStreams from "../views/customer-streams";
import CommonUtils from "../util/CommonUtils";

export default function Router() {
    const allowAppAccess = new SessionManager().readCookie('user', false);
    const Layout = () => {
        if (!allowAppAccess) {
            let pathname = window.location.pathname;
            let redirect_prefixes = ['/event/'];
            let post_login_redirect = false;

            for (let r of redirect_prefixes)
                if (pathname.startsWith(r))
                    post_login_redirect = true;

            window.location = post_login_redirect ? window.location.origin + '?redirectUrl=' + pathname : '/';
        }

        let pathname = window.location.pathname;
        let hideHeaderRoutes = ['/executive-dashboard'];
        let shouldShowHeader = !hideHeaderRoutes.includes(pathname) && !pathname.startsWith('/stream/');
        let shouldShowChatbot = !hideHeaderRoutes.includes(pathname) && !pathname.startsWith('/stream/');

        return <>
            {shouldShowHeader && <Header />}
            {allowAppAccess && <Outlet />}
            {allowAppAccess && shouldShowChatbot && CommonUtils.hasPermission('SITESUPT-UI-CHATBOT') && <ChatbotWidget />}
        </>
    }

    const BrowserRoutes = createBrowserRouter([
        { path: "/", element: <Login /> },
        { path: "/marketplace", element: <Procore /> },
        { path: "/forgot-password", element: <ForgotPassword /> },
        { path: "/settings", element: <SSO /> },
        { path: "/stream/:token", element: <CustomerStreams exact /> },
        {
            path: "/",
            element: <Layout />,
            children: [
                { path: "/dashboard", element: <DashboardSites /> },

                { path: "/message", element: <Message /> },
                { path: "/dashboard", element: <DashboardSites exact /> },
                { path: "/dashboard-exec", element: <DashboardLeadership exact /> },
                { path: "/sitemap", element: <DashboardSitemap exact /> },
                { path: "/owners-portal", element: <DashboardOwners exact /> },
                { path: "/map-view", element: <DashboardMapView exact /> },
                { path: "/timelapse-dashboard", element: <TimelapseDashboard /> },
                { path: "/sensors-dashboard", element: <SensorsDashboard /> },
                { path: "/site-management", element: <SiteManagement exact /> },
                { path: "/reports", element: <ReportsHome exact /> },
                { path: "/ppe-reports-library", element: <PPEReportsLibrary /> },
                { path: "/reports/reports-library", element: <ReportLibraryPage /> },
                { path: "/dashboard/zone-history", element: <ZoneHistory /> },
                { path: "/profile-settings", element: <ProfileSettings /> },
                { path: "/admin-console", element: <AdminConsole /> },
                { path: "/videos", element: <VideosHome exact /> },
                { path: "/videos/video-library", element: <VideosLibrary /> },
                { path: "/videos/historical-videos", element: <VideosHistorical /> },
                { path: "/support/how-to-videos", element: <HowToVideos /> },
                { path: "/support/faqs", element: <FAQPage /> },
                { path: "/support/third-party-monitoring", element: <ThirdPartyMonitoring /> },

                { path: "/whirc-incident-manager", element: <WhircIncidentManager /> },

                { path: "/bim-models", element: <BIMModels /> },
                { path: "/bim-viewer", element: <BIMViewer /> },
                { path: "/videos/timelapse-video", element: <ZoneTimelaps exact /> },
                { path: "/timelapse-video/:id", element: <ZoneTimelaps exact /> },
                { path: "/file-dashboard", element: <FileDashboard exact /> },
                /* Error */
                { path: "/page-error", element: <ErrorPage /> },
                { path: "*", element: <ErrorPage /> },
            ]
        },

        { path: "/event/:event_id", element: <AITextNotification /> },
        { path: "/live-stream/:location_name", element: <LiveStream /> },
        { path: "/live-stream", element: <LiveStream /> },

        /* Reports */
        { path: "/daily-report/:pdf", element: <DailyReport /> },
        { path: "/man-power-report/:pdf", element: <HumanPowerReport /> },
        { path: "/standard-daily-report/:pdf", element: <StandardDailyReport /> },
        { path: "/environmental-report/:pdf", element: <EnvironmentalReport /> },
        { path: "/after-hours-visitors-report/:pdf", element: <AfterHoursVisitorsReport /> },
        { path: "/ppe-awareness-daily-report/:pdf", element: <PPEAwarenessDailyReport /> },
        { path: "/rain-report/:pdf", element: <RainReport /> },
        { path: "/wind-report/:pdf", element: <WindReport /> },
        { path: "/sensor-details/:pdf", element: <SensorDetails /> },
        { path: "/uptime-report/:pdf", element: <UptimeReport /> },
        { path: "/site-monitoring-report", element: <SiteMonitoringReport /> },
        { path: "/security-incident-report", element: <SecurityIncidentReport /> },

        { path: "/welcome", element: <Login /> },

        /** Login Related */
        { path: "/login", element: <Login /> },
        { path: "/logout", element: <Logout /> },
        { path: "/verify-token", element: <VerifyChallenge /> },
        { path: "/renew-password", element: <PasswordRenewal /> },
        { path: "/forgot-password", element: <ForgotPassword /> }

    ])

    return <RouterProvider router={BrowserRoutes} />;

}